var map = {
	"./sticker_blue_number_0.png": 3026,
	"./sticker_blue_number_1.png": 8774,
	"./sticker_blue_number_2.png": 8941,
	"./sticker_blue_number_3.png": 2043,
	"./sticker_blue_number_4.png": 1714,
	"./sticker_blue_number_5.png": 1990,
	"./sticker_blue_number_6.png": 2542,
	"./sticker_blue_number_7.png": 7956,
	"./sticker_blue_number_8.png": 2267,
	"./sticker_blue_number_9.png": 2132
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9765;